import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['sail', 0.22],
        ['tavern', 0.78],
      ],
      d: 'M-2.5,-3.5h1.5v0.5h-1.5zM-2,-3h2.5v0.5h-2.5zM-2.5,-2.5h1v0.5h-1zM0,-2.5h0.5v0.5h-0.5zM-2,-2h1v0.5h-1zM-0.5,-2h0.5v0.5h-0.5zM-2.5,-1.5h1v2h-1zM0,-1.5h0.5v2.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['tavern', 0.76],
      ],
      d: 'M3,-4h0.5v0.5h-0.5zM-3,-3.5h0.5v0.5h-0.5zM2,-3.5h1.5v0.5h-1.5zM-2.5,-3h0.5v0.5h-0.5zM1,-3h2.5v0.5h-2.5zM-3,-2.5h0.5v3h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM0.5,-2.5h3v0.5h-3zM-1,-2h0.5v0.5h-0.5zM0,-2h0.5v0.5h-0.5zM1,-2h2.5v0.5h-2.5zM-0.5,-1.5h0.5v2.5h-0.5zM0.5,-1.5h3v2h-3zM0.5,0.5h2v0.5h-2zM1,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofB',
      d: 'M-1.5,-6h1.5v0.5h-1.5zM-2,-5.5h2v0.5h-2zM-2.5,-5h2.5v0.5h-2.5zM-3,-4.5h3.5v0.5h-3.5zM-3.5,-4h0.5v0.5h-0.5zM-2.5,-4h3v0.5h-3zM-0.5,-3.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofB', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-0.5,-6.5h0.5v0.5h-0.5zM0,-6h1.5v0.5h-1.5zM0,-5.5h2.5v0.5h-2.5zM0,-5h3v0.5h-3zM0.5,-4.5h3v0.5h-3zM-3,-4h0.5v0.5h-0.5zM0.5,-4h2.5v0.5h-2.5zM-1,-3.5h0.5v0.5h-0.5zM1,-3.5h1v0.5h-1zM0.5,-3h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M3,-5h2v0.5h-2zM-3,-3h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v2h-1zM-1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'lanternGlow', d: 'M-2.5,-2h0.5v0.5h-0.5z' },
    {
      paint: 'tavernSign',
      d: 'M3.5,-4.5h2v0.5h-2zM3.5,-4h0.5v1h-0.5zM5,-4h0.5v0.5h-0.5zM4.5,-3.5h1v0.5h-1zM3.5,-3h1.5v0.5h-1.5z',
    },
    { paint: 'wheat', d: 'M4,-4h1v0.5h-1zM4,-3.5h0.5v0.5h-0.5z' },
  ],
  pixels: 186,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
